module.exports = __webpack_public_path__ + "img/moon_icon.b393a3c4.svg";